var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_show==false),expression:"is_show==false"}],staticClass:"player-demo"},[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"m-left"},[_c('div',{ref:"playerTemp",staticClass:"player-olympic"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }